import React, { useState, useEffect } from "react";
import moment from "moment";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import {
  getData,
  getDataWithComp,
  formatCurrency,
  parseCurrency,
  getViewAp,
} from "../../../../utils/SamuiUtils";
import { getReport } from "../../../../utils/ReportUtils";
// import { formatDate } from "../../../../utils/DateUtils";
import WtaxModal from "../../../components/Modal/WtaxModal";

import { payMasterModel } from "../../../../model/Purchase/PayMasterModel";

const Main = ({ name, dataMasterList, onPageInsert, onPageUpdate }) => {
  const [filteredDetailList, setFilteredDetailList] = useState([]);
  const [docNo, setDocNo] = useState("");
  const [arNameMap, setArNameMap] = useState({});

  const [searchItemTerm, setSearchItemTerm] = useState("");
  const [showWTModal, setShowWTModal] = useState(false);
  const handleWTClose = () => setShowWTModal(false);
  const [apDataList, setApDataList] = useState([]);
  const [totalWT, setTotalWT] = useState(0);
  const [inputValueTotalWT, setInputValueTotalWT] = useState("0.00");
  const [selectedOption, setSelectedOption] = useState(1);
  const currentDate = moment().add(543, "years").format("DD/MM/YYYY");
  const [taxData, setTaxData] = useState([
    {
      id: 1,
      type: 5,
      percent: 3.0,
      date: currentDate,
      amount: 0.0,
      tax: 0.0,
      remark: "",
    },
    {
      id: 2,
      type: 6,
      percent: 3.0,
      date: currentDate,
      amount: 0.0,
      tax: 0.0,
      remark: "",
    },
  ]);
  const [taxtotalAmount, setTaxtotalAmount] = useState(0);
  const [formMasterList, setFormMasterList] = useState([payMasterModel()]);
  console.debug("formMasterList", formMasterList);
  const [docRef, setDocRef] = useState("");
  const [Ref_PAY_ID, setRef_PAY_ID] = useState();
  const [mode, setMode] = useState("I");

  // Fetch AR Names
  useEffect(() => {
    const fetch = async () => {
      // const arMap = {};
      // for (const item of dataMasterList) {
      //   if (item?.WT_AR_Id && !arMap[item.WT_AR_Id]) {
      //     const result = await getData(
      //       "Tb_Set_AR",
      //       `AR_Id = ${item?.WT_AR_Id}`
      //     );
      //     arMap[item?.WT_AR_Id] = result.at(0).AR_Name || "Unknown";
      //   }
      // }
      // setArNameMap(arMap);
      const apDataList = await getViewAp();
      if (apDataList && apDataList.length > 0) {
        setApDataList(apDataList);
        // setRef_PAY_ID(maxPayNo);
        // setDocRef(maxPayNo);
      }
    };

    if (dataMasterList?.length > 0) {
      fetch();
    }
  }, [dataMasterList]);

  const onRowSelected = async (fromData) => {
    // const dataDetailList = await getData(
    //   "API_1302_BL_D",
    //   `Doc_Id = ${parseCurrency(fromData?.Doc_Id)}`
    // );

    // setFilteredDetailList(dataDetailList?.length > 0 ? dataDetailList : []);
    setDocNo(fromData.WTAX_No);
  };
  const filteredItemData = dataMasterList;

  const Type = (type) => {
    switch (type) {
      case 1:
        return "ภ.ง.ด.1ก.";
      case 2:
        return "ภ.ง.ด.1ก.พิเศษ";
      case 3:
        return "ภ.ง.ด.2";
      case 4:
        return "ภ.ง.ด.3";
      case 5:
        return "ภ.ง.ด.2ก.";
      case 6:
        return "ภ.ง.ด.3ก.";
      case 7:
        return "ภ.ง.ด.53";
      default:
        return "ไม่พบข้อมูล";
    }
  };

  // const filteredItemData = dataMasterList?.filter((data) => {
  //   return data?.WTAX_Id.toLowerCase().includes(searchItemTerm.toLowerCase());
  // });

  const Insert = () => {
    setMode("I");
    setFormMasterList([payMasterModel()]);
    setDocRef("");
    const currentDate = moment().add(543, "years").format("DD/MM/YYYY");
    setTaxData([
      {
        id: 1,
        type: 5,
        percent: 3.0,
        date: currentDate,
        amount: 0.0,
        tax: 0.0,
        remark: "",
      },
      {
        id: 2,
        type: 6,
        percent: 3.0,
        date: currentDate,
        amount: 0.0,
        tax: 0.0,
        remark: "",
      },
    ]);
    setSelectedOption(3);
    setShowWTModal(true);
  };

  const update = async (data) => {
    try {
      const tax = await getDataWithComp(
        "API_1701_WTAX_H",
        `and WTAX_No = '${data}'`
      );

      const taxD = await getDataWithComp(
        "API_1702_WTAX_D",
        `and WTAX_No = '${data}'`
      );

      if (!tax || tax.length === 0) {
        console.warn("ไม่พบข้อมูล WTAX");
        return;
      }

      const taxItem = tax[0] || {};
      const taxItemD = taxD[0] || {}; // ป้องกัน undefined

      setDocRef(taxItem?.Ref_Doc);
      setRef_PAY_ID(taxItem?.Ref_Doc?.startsWith("PAY") ? taxItem?.Ref_Doc : null);


      setFormMasterList((prevState) => ({
        ...prevState, // ใช้ค่าเดิมของ state
        payId: taxItem?.Pay_Id,
        apID: taxItem?.AP_Id,
        apCode: taxItem?.AP_Code,
        apName: taxItem?.AP_Name,
        apAdd1: taxItem?.AP_Add1,
        apAdd2: taxItem?.AP_Add2,
        apAdd3: taxItem?.AP_Add3,
        apProvince: taxItem?.AP_Province,
        apZipcode: taxItem?.AP_Zipcode,
        apTaxNo: taxItem?.AP_TaxNo,
      }));

      // ตรวจสอบว่า WTAX_Date มีค่าหรือไม่ก่อนใช้ moment()
      const formattedDate = taxItemD?.WTAX_Date
        ? moment.utc(taxItemD.WTAX_Date).format("DD/MM/YYYY")
        : "";
      console.debug("taxD", taxItem, taxItemD);
      setTaxData([
        {
          id: 1,
          type: taxItemD?.WTAX_TypeNo || "",
          percent: taxItemD?.WTAX_Percent || 0,
          date: formattedDate, // ใช้ค่าที่ตรวจสอบแล้ว
          amount: taxItemD?.WTAX_Total || 0,
          tax: taxItemD?.WTAX_Total_Tax || 0,
          remark: taxItemD?.WTAX_Desc || "",
          Wtax_Id: taxItem?.WTAX_Id || "",
          Wtax_No: taxItem?.WTAX_No || "",
        },
      ]);
      setSelectedOption(taxItem.WTAX_Type || 1);
      setMode("U");
      setShowWTModal(true);
    } catch (error) {
      console.error("เกิดข้อผิดพลาดในการโหลดข้อมูลภาษี:", error);
    }
  };

  return (
    <>
      <Breadcrumbs
        page={name}
        items={[
          { name: "งานบัญชี", url: "/account" },
          { name: name, url: "/tax" },
        ]}
      />
      <div
        className="container-fluid card py-3 hidden-scrollbar"
        style={{ maxHeight: "80vh", overflowY: "auto" }}
      >
        <div className="row mb-2 align-items-center">
          <div className="col-1">
            <button
              className="btn text-white mx-3"
              onClick={() => Insert()}
              style={{
                backgroundColor: "rgb(239, 108, 0)",
                whiteSpace: "nowrap",
                padding: "10px",
                fontSize: "15px",
              }}
            >
              <i className="fa fa-plus" aria-hidden="true"></i> {name}
            </button>
            <WtaxModal
              showWTModal={showWTModal}
              handleWTClose={handleWTClose}
              apDataList={apDataList}
              setTotalWT={setTotalWT}
              setInputValueTotalWT={setInputValueTotalWT}
              selectedOption={selectedOption}
              setSelectedOption={setSelectedOption}
              taxData={taxData}
              setTaxData={setTaxData}
              setTaxtotalAmount={setTaxtotalAmount}
              formMasterList={formMasterList}
              setFormMasterList={setFormMasterList}
              docRef={docRef}
              setDocRef={setDocRef}
              Ref_PAY_ID={Ref_PAY_ID}
              setRef_PAY_ID={setRef_PAY_ID}
              mode={mode}
            />
          </div>
          <div className="col-4" style={{ marginLeft: 55 }}>
            <div className="input-group">
              <span className="input-group-text">Search</span>
              <input
                type="text"
                className="form-control"
                value={searchItemTerm}
                onChange={(e) => setSearchItemTerm(e.target.value)}
              />
            </div>
          </div>
          <div className="col-7"></div>
        </div>
        <hr />
        <div className="row">
          <div className=" mb-1" style={{ borderRight: "2px solid #c7c8c9" }}>
            <div
              className="table-responsive"
              style={{ maxHeight: "650px", overflowY: "auto" }}
            >
              <table
                id="basic-datatables"
                className="table table-striped table-hover"
              >
                <thead className="thead-dark">
                  <tr>
                    <th className="text-center" style={{ width: "3%" }}>
                      #
                    </th>
                    <th className="text-center" style={{ width: "10%" }}>
                      เลขที่เอกสาร
                    </th>
                    <th className="text-center" style={{ width: "30%" }}>
                      ผู้ถูกหักภาษี ณ ที่จ่าย
                    </th>
                    <th className="text-center" style={{ width: "10%" }}>
                      เอกสารอ้างอิง
                    </th>
                    <th className="text-center" style={{ width: "10%" }}>
                      ประเภทแบบ
                    </th>
                    <th className="text-center" style={{ width: "10%" }}>
                      วันที่ออก
                    </th>

                    <th className="text-center" style={{ width: "10%" }}>
                      ยอดเงินรวม
                    </th>
                    <th className="text-center" style={{ width: "10%" }}>
                      ยอดหักภาษี
                    </th>
                    <th className="text-center" style={{ width: "1%" }}>
                      แก้ไข
                    </th>
                    <th
                      className="text-center"
                      style={{ width: "1%" }}
                      hidden={
                        window.location.pathname === "/payment-voucher" ||
                        window.location.pathname === "/picking-list"
                          ? true
                          : false
                      }
                    >
                      พิมพ์
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {filteredItemData.length > 0 ? (
                    filteredItemData.map((data, index) => (
                      <tr
                        key={data.WTAX_Id || index + 1}
                        onClick={() => onRowSelected(data)}
                        style={{ cursor: "pointer" }}
                      >
                        <td className="text-center">
                          {index + 1}
                          {/* {formatThaiDateUi(data.Doc_Date)} */}
                        </td>
                        <td className="text-center">{data.WTAX_No}</td>
                        <td className=""> {data.AP_Name || "-"}</td>
                        <td className="text-center">{data.Ref_Doc || "-"}</td>
                        <td className="text-center">
                          {Type(data.WTAX_Type) || "-"}
                        </td>
                        <td className="text-center">
                          {moment
                            .utc(data?.WTAX_Date)
                            .format("DD/MM/YYYY")}
                        </td>
                        <td className="text-end">
                          {formatCurrency(data?.WTAX_Total)}
                        </td>
                        <td className="text-end">
                          {formatCurrency(data?.WTAX_Total_Tax)}
                        </td>
                        <td className="text-center">
                          <button
                            className="btn btn-sm"
                            onClick={() => update(data.WTAX_No)}
                          >
                            <i
                              className="fa fa-edit"
                              style={{ color: "rgb(239, 108, 0)" }}
                            />
                          </button>
                        </td>
                        <td className="text-center">
                          <>
                            <button
                              className="btn btn-link btn-sm px-3"
                              onClick={() => {
                                getReport("TAX", data.WTAX_Id);
                              }}
                            >
                              <i
                                className="fa fa-print"
                                style={{ fontSize: "16px" }}
                              ></i>
                            </button>
                            {/* {showOptionInvModal && (
                              <PrintInvoiceModal
                                showOptionInvModal={showOptionInvModal}
                                setShowOptionInvModal={setShowOptionInvModal}
                                onHandleInvoice1={() =>
                                  getReport("inv1", selectInvNo)
                                }
                                onHandleInvoice2={() =>
                                  getReport("inv2", selectInvNo)
                                }
                              />
                            )} */}
                          </>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7">
                        <center>
                          <h5>ไม่พบข้อมูล</h5>
                        </center>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Main;
